"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scanner = void 0;

var Token_1 = require("./Token");

var ROW_DELIMITER = /((?:\r\n)|\n|\r)/;

var Scanner = /*#__PURE__*/function () {
  function Scanner(args) {
    _classCallCheck(this, Scanner);

    this.cursor = 0;
    this.line = args.line;
    this.lineLength = this.line.length;
    this.parserOptions = args.parserOptions;
    this.hasMoreData = args.hasMoreData;
    this.cursor = args.cursor || 0;
  }

  _createClass(Scanner, [{
    key: "hasMoreCharacters",
    get: function get() {
      return this.lineLength > this.cursor;
    }
  }, {
    key: "nextNonSpaceToken",
    get: function get() {
      var lineFromCursor = this.lineFromCursor;
      var regex = this.parserOptions.NEXT_TOKEN_REGEXP;

      if (lineFromCursor.search(regex) === -1) {
        return null;
      }

      var match = regex.exec(lineFromCursor);

      if (match == null) {
        return null;
      }

      var token = match[1];
      var startCursor = this.cursor + (match.index || 0);
      return new Token_1.Token({
        token: token,
        startCursor: startCursor,
        endCursor: startCursor + token.length - 1
      });
    }
  }, {
    key: "nextCharacterToken",
    get: function get() {
      var cursor = this.cursor,
          lineLength = this.lineLength;

      if (lineLength <= cursor) {
        return null;
      }

      return new Token_1.Token({
        token: this.line[cursor],
        startCursor: cursor,
        endCursor: cursor
      });
    }
  }, {
    key: "lineFromCursor",
    get: function get() {
      return this.line.substr(this.cursor);
    }
  }, {
    key: "advancePastLine",
    value: function advancePastLine() {
      var match = ROW_DELIMITER.exec(this.lineFromCursor);

      if (!match) {
        if (this.hasMoreData) {
          return null;
        }

        this.cursor = this.lineLength;
        return this;
      }

      this.cursor += (match.index || 0) + match[0].length;
      return this;
    }
  }, {
    key: "advanceTo",
    value: function advanceTo(cursor) {
      this.cursor = cursor;
      return this;
    }
  }, {
    key: "advanceToToken",
    value: function advanceToToken(token) {
      this.cursor = token.startCursor;
      return this;
    }
  }, {
    key: "advancePastToken",
    value: function advancePastToken(token) {
      this.cursor = token.endCursor + 1;
      return this;
    }
  }, {
    key: "truncateToCursor",
    value: function truncateToCursor() {
      this.line = this.lineFromCursor;
      this.lineLength = this.line.length;
      this.cursor = 0;
      return this;
    }
  }]);

  return Scanner;
}();

exports.Scanner = Scanner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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